<template>
    <div>
        <template v-if="viewPage === true && feeExternalVoucher !== null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Fee External Voucher Detail </h1>
            </div>
            <div class="vendor-profile-box mb-3">
                <div class="row mb-4">
                    <div class="col">
                        <div class="vendor-profile-head clearfix">
                            <h2> {{feeExternalVoucher.reference_name}} </h2>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Challan Number </span>
                        <p class="value-text"> {{feeExternalVoucher.challan_number}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Reference Number </span>
                        <p class="value-text"> {{feeExternalVoucher.reference_number}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Due Date </span>
                        <p class="value-text"> {{feeExternalVoucher.due_date}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Amount Within DueDate </span>
                        <p class="value-text"> {{feeExternalVoucher.amount_within_duedate}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Amount After DueDate </span>
                        <p class="value-text"> {{feeExternalVoucher.amount_after_duedate}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Status </span>
                        <p class="value-text"> {{feeExternalVoucher.status}} </p>
                    </div>
                </div>
            </div>
            <h3 class="vendor-profile-heading mb-3"> Payments </h3>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
                    <table id="paymentDetail" class="table table-responsive-xl" style="width:100%">
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Transaction Number</th>
                            <th>Date</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(payment, index) in feeExternalVoucherPayments">
                            <td> {{index + 1}} </td>
                            <td>{{payment.transaction_number}}</td>
                            <td>{{payment.transaction_date}}</td>
                            <td>{{payment.amount}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === null && feeExternalVoucher === null">
            <div class="inside-loader">
                <div class="inside-loader-inner">
                    <img src="/images/payroll.png" alt="" />
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage : null,
                feeExternalVoucher : null,
                feeExternalVoucherPayments : null
            };
        },
        mounted() {
            this.$Progress.start();
            this.getFeeExternalVoucherDetailData();
            this.$Progress.finish();
        },
        methods: {
            getFeeExternalVoucherDetailData : function () {
                axios.get('/api/feeExternalVoucherDetail/'+this.$route.params.id)
                    .then(res => {
                        if(res.status == 200){
                            this.viewPage = res.data.viewPage;
                            this.feeExternalVoucher = res.data.feeExternalVoucher;
                            this.feeExternalVoucherPayments = res.data.feeExternalVoucherPayments;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load fee external voucher detail');
                        }
                    })
                    .then(res =>{
                        var feeExternalVoucherPaymentsTable = $('#paymentDetail').DataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                            deferRender: true,
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load fee external vouhcer detail');
                    });
            }
        },
        created() {
            //
        }
    }
</script>
